import { useContext } from 'react';

import AuthContext from '../context/auth/authContext.jsx';

const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
